import React from 'react';
import { Typography } from 'antd';
import styles from './CarbonSustain.module.scss';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const CarbonSustain: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.climateTradeContainer}>
      <Title level={3} className={styles.climateTradeTitle}>
        <h2>{t('carbonSustain')}</h2>
      </Title>
      <Text>{t('carbonSustainContent')}</Text>

      <div className={styles.imageGallery}>
        <img src='/images/clean-water.jpg' alt='Clear Water' className={styles.image} />
        <img src='/images/climate-action.jpg' alt='Climate Action' className={styles.image} />
        <img src='/images/decent-work.jpg' alt='Decent Work' className={styles.image} />
        <img src='/images/life-on-land.jpg' alt='Life on Land' className={styles.image} />
        <img src='/images/consumption.jpg' alt='Responsible Consumption' className={styles.image} />
      </div>
    </div>
  );
};

export default CarbonSustain;
